import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireRole } from '@/lib/routeGuards';

/** Layout-гард кабинета владельца: /owner/* доступен только owner. */
export const Route = createFileRoute('/_authed/owner')({
  beforeLoad: () => requireRole('owner'),
  component: Outlet,
});
